<div class="py-4 container-fluid disb-reg-page">
  <h4 class="mb-4 disb-reg-title">ข้อมูลเอกสารส่งเบิก</h4>

  @if (isRoundExportRole) {
    <div class="segmented-tabs disb-reg-tabs" role="tablist" aria-label="เลือกมุมมองข้อมูลเอกสารส่งเบิก">
      <button
        type="button"
        id="disbRegTabList"
        class="segmented-tab"
        role="tab"
        aria-controls="disbRegPanelList"
        [attr.aria-selected]="activeTab() === 'list'"
        [class.active]="activeTab() === 'list'"
        (click)="onTabChange('list')"
      >
        เอกสารส่งเบิก
      </button>
      <button
        type="button"
        id="disbRegTabRounds"
        class="segmented-tab"
        role="tab"
        aria-controls="disbRegPanelRounds"
        [attr.aria-selected]="activeTab() === 'rounds'"
        [class.active]="activeTab() === 'rounds'"
        (click)="onTabChange('rounds')"
      >
        เอกสารส่งเบิกฉบับรวม
      </button>
    </div>
  }

  <!-- Kept outside every tab panel: `static: true` ViewChild reads run before the first
       change detection, so a template inside a control-flow block would be undefined by
       the time initColumns() builds the datatable columns. -->
  <ng-template #statusTemplate let-row="row">
    <app-status-badge
      [tone]="row.badgeTone"
      [label]="row.badgeLabel"
      [tooltip]="row.badgeTooltip"
    />
  </ng-template>

  <ng-template #actionTemplate let-row="row">
    @if (row.certificationId !== null) {
      <button
        type="button"
        class="btn disb-reg-action-button datatable-view-action-button"
        aria-label="ดูรายละเอียดเอกสารส่งเบิก"
        (click)="onView(row)"
      >
        <img
          src="assets/media/icons/svg/eye.svg"
          class="disb-reg-action-icon datatable-view-action-icon"
          alt=""
          aria-hidden="true"
        />
      </button>
    }
  </ng-template>

  <div class="disb-reg-card">
    <div class="disb-reg-card-body">
      <div class="disb-reg-toolbar" [formGroup]="filterForm">
        <div class="disb-reg-filter">
          <app-select
            label="เทอมการศึกษา"
            labelSize="compact"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-reg-filter">
          <app-select
            label="ปีการศึกษา"
            labelSize="compact"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        @if (showDepartmentFilter) {
          <div class="disb-reg-filter">
            <app-select
              label="สาขาวิชา"
              labelSize="compact"
              formControlName="departmentId"
              [options]="departmentOptions"
              bindLabel="name"
              bindValue="id"
              [clearable]="true"
              [searchable]="true"
              inputClass="ng-select-size-md"
              classes="mb-0"
            ></app-select>
          </div>
        }

        @if (showStatusFilter) {
          <div class="disb-reg-filter">
            <app-select
              label="สถานะ"
              labelSize="compact"
              formControlName="statusFilter"
              [options]="statusOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="true"
              [searchable]="false"
              inputClass="ng-select-size-md"
              classes="mb-0"
            ></app-select>
          </div>
        }

        @if (showKeywordSearch) {
          <div class="disb-reg-search">
            <app-filter-search-input
              [label]="keywordSearchLabel"
              formControlName="keywords"
              [ariaLabel]="keywordSearchLabel"
              classes="mb-0"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>
        }
      </div>

      @if (activeTab() === 'list') {
        <div
          id="disbRegPanelList"
          class="disb-reg-tab-panel"
          [attr.role]="isRoundExportRole ? 'tabpanel' : null"
          [attr.aria-labelledby]="isRoundExportRole ? 'disbRegTabList' : null"
        >
          @if (showStatusSubTabs) {
            <div class="segmented-tabs segmented-tabs--sm disb-reg-status-tabs" role="tablist" aria-label="สถานะเอกสารส่งเบิก">
              @for (tab of statusTabs; track tab.key) {
                <button
                  type="button"
                  class="segmented-tab"
                  role="tab"
                  [attr.aria-selected]="statusTab() === tab.key"
                  [class.active]="statusTab() === tab.key"
                  (click)="onStatusTabChange(tab.key)"
                >
                  {{ tab.label }}
                </button>
              }
            </div>
          }

          <app-datatable
            [datasource]="datasource()"
            [columns]="columns"
            [isLoading]="tableLoading()"
            [limit]="50"
            [showFooter]="false"
            (sortChange)="onSortChange($event)"
          ></app-datatable>

          <app-table-pagination
            [page]="datasource().page"
            [limit]="datasource().limit"
            [total]="datasource().total"
            [totalPage]="datasource().total_page"
            [offset]="datasource().offset"
            [dataLength]="datasource().data.length"
            ariaLabel="disbursement registry pagination"
            (pageChange)="onPageChange($event)"
            (limitChange)="onLimitChange($event)"
          ></app-table-pagination>
        </div>
      }

      @if (isRoundExportRole && activeTab() === 'rounds') {
        <div
          id="disbRegPanelRounds"
          class="disb-reg-tab-panel"
          role="tabpanel"
          aria-labelledby="disbRegTabRounds"
        >
          <h6 class="disb-reg-round-export-title">เอกสารรวมของแต่ละรอบส่งเบิก</h6>
          <p class="disb-reg-round-export-caption">
            เอกสารส่งเบิกที่ได้รับการอนุมัติจากรองคณบดีฝ่ายบริหารครบถ้วนแล้ว สามารถกด Export
            เพื่อดูตัวอย่างและดาวน์โหลดเอกสารได้
          </p>

          <div class="disb-reg-round-export-search" [formGroup]="roundFilterForm">
            <app-filter-search-input
              label="เลขที่เอกสาร"
              formControlName="documentNumber"
              ariaLabel="ค้นหาเลขที่เอกสารของรอบส่งเบิก"
              classes="mb-0"
            ></app-filter-search-input>
          </div>

          @if (completedRoundsLoading()) {
            <p class="disb-reg-round-export-loading">กำลังโหลดข้อมูล...</p>
          } @else if (filteredCompletedRounds().length === 0) {
            <p class="disb-reg-round-export-empty">ยังไม่มีรอบส่งเบิกที่เสร็จสิ้นสำหรับเทอมการศึกษานี้</p>
          } @else {
            <ul class="disb-reg-round-export-list">
              @for (round of filteredCompletedRounds(); track round.id) {
                <li class="disb-reg-round-export-item">
                  <div class="disb-reg-round-export-row">
                    <div class="disb-reg-round-export-row-meta">
                      <span class="disb-reg-round-export-row-title">{{ completedRoundTitle(round) }}</span>
                      <span class="disb-reg-round-export-row-sub">{{ completedRoundDepartment(round) }} · ลงวันที่ {{ formatDate(round.issued_on) }}</span>
                    </div>
                    <div class="disb-reg-round-export-row-actions">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm disb-reg-round-export-button"
                        [disabled]="!round.export_ready"
                        [title]="round.export_ready ? 'ดูตัวอย่างและดาวน์โหลดเอกสารรวมของรอบนี้' : 'ระบบกำลังจัดทำเอกสารของรอบนี้ กรุณารอสักครู่'"
                        (click)="onOpenExportModal(round)"
                      >
                        Export
                      </button>
                      @if (hasBreakdownToggle(round)) {
                        <button
                          type="button"
                          class="disb-reg-breakdown-toggle"
                          [attr.aria-expanded]="isBreakdownExpanded(round)"
                          [attr.aria-controls]="breakdownListId(round)"
                          [attr.aria-label]="breakdownToggleTitle(round)"
                          [title]="breakdownToggleTitle(round)"
                          (click)="onToggleBreakdown(round)"
                        >
                          <svg
                            class="disb-reg-breakdown-toggle-caret"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </button>
                      }
                    </div>
                  </div>

                  @if (hasBreakdownToggle(round) && isBreakdownExpanded(round)) {
                    <section class="disb-reg-breakdown" [id]="breakdownListId(round)">
                      <h6 class="disb-reg-breakdown-title">รายละเอียดการเบิกจ่ายรายบุคคล</h6>
                      @if (isBreakdownLoading(round)) {
                        <p class="disb-reg-breakdown-state">กำลังโหลดรายละเอียดการเบิกจ่าย...</p>
                      } @else if (hasBreakdownError(round)) {
                        <p class="disb-reg-breakdown-state disb-reg-breakdown-state--error">
                          โหลดรายละเอียดการเบิกจ่ายไม่สำเร็จ กรุณาปิดแล้วกดดูใหม่อีกครั้ง
                        </p>
                      } @else {
                        @if (breakdownOf(round); as breakdown) {
                          @if (breakdown.teachers.length === 0) {
                            <p class="disb-reg-breakdown-state">ไม่มีรายการเบิกจ่ายรายบุคคลในรอบนี้</p>
                          } @else {
                            <ul class="disb-reg-breakdown-list">
                              @for (teacher of breakdown.teachers; track teacher.user_id) {
                                <li class="disb-reg-breakdown-teacher">
                                  <div class="disb-reg-breakdown-row disb-reg-breakdown-row--teacher">
                                    <span class="disb-reg-breakdown-name">{{ teacher.full_name || '-' }}</span>
                                    <span class="disb-reg-breakdown-amount">{{ formatAmount(teacher.amount) }}</span>
                                  </div>
                                  @for (item of teacher.items; track $index) {
                                    <div class="disb-reg-breakdown-row disb-reg-breakdown-row--item">
                                      <span class="disb-reg-breakdown-name">{{ breakdownItemLabel(item) }}</span>
                                      <span class="disb-reg-breakdown-amount">{{ formatAmount(item.amount) }}</span>
                                    </div>
                                  }
                                </li>
                              }
                            </ul>
                            <div class="disb-reg-breakdown-row disb-reg-breakdown-row--total">
                              <span class="disb-reg-breakdown-name">รวมทั้งสิ้น</span>
                              <span class="disb-reg-breakdown-amount">{{ formatAmount(breakdown.total) }} บาท</span>
                            </div>
                            @if (breakdown.unattributed_total > 0) {
                              <p class="disb-reg-breakdown-note">
                                มียอด {{ formatAmount(breakdown.unattributed_total) }} บาท
                                ที่แจกแจงรายบุคคลไม่ได้ กรุณาตรวจสอบจากเอกสารรวมของรอบ
                              </p>
                            }
                          }
                        }
                      }
                    </section>
                  }
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </div>
</div>

@if (exportTarget(); as round) {
  <div class="disb-reg-export-modal-overlay" role="presentation">
    <div
      class="disb-reg-export-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbRegExportTitle"
    >
      <div class="disb-reg-export-modal-header">
        <div class="disb-reg-export-modal-heading">
          <h5 id="disbRegExportTitle">รอบส่งเบิก — {{ completedRoundLabel(round) }}</h5>
          <span class="disb-reg-export-modal-subtitle">{{ exportModalSubtitle(round) }}</span>
        </div>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิด"
          [disabled]="exportDownloading()"
          (click)="onCloseExportModal()"
        ></button>
      </div>

      <div class="disb-reg-export-modal-body">
        @if (exportPreviewLoading()) {
          <p class="disb-reg-export-modal-loading">กำลังโหลดเอกสารรวมของรอบ...</p>
        } @else {
          @if (exportPreviewError(); as message) {
            <p class="disb-reg-export-modal-error">{{ message }}</p>
          } @else {
            @if (exportPreviewUrl(); as url) {
              <iframe
                class="disb-reg-export-modal-frame"
                [src]="url"
                title="ตัวอย่างเอกสารรวมของรอบส่งเบิก"
              ></iframe>
            }
          }
        }
      </div>

      <div class="disb-reg-export-modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="exportDownloading()"
          (click)="onCloseExportModal()"
        >
          ปิด
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="exportDownloading()"
          (click)="onConfirmExport()"
        >
          {{ exportDownloading() ? 'กำลังดาวน์โหลด...' : 'Export' }}
        </button>
      </div>
    </div>
  </div>
}
